import { NgModule } from '@angular/core';
import { TableAndColumnSizeDirective } from './angular-table-resizable-columns.directive';
import { TableRowMovementDirective } from './table-row-movement2';

@NgModule({
  declarations: [TableAndColumnSizeDirective, TableRowMovementDirective],
  imports: [],
  exports: [TableAndColumnSizeDirective, TableRowMovementDirective],
})
export class ResizeColumnModule {}
